class HiddenCheckboxManager
{
    constructor() {
        this.run();
    }
    run() {
        document.querySelectorAll('[data-hidden-checkbox]').forEach(el => new HiddenCheckbox(el))
    }
}

class HiddenCheckbox {
    constructor(el) {
        this.el = el
        this.elDst = document.querySelector('[data-hidden-checkbox-dst=' + this.el.dataset.hiddenCheckbox + ']');
        this._init();
    }
    _init() {
        if(!this.el) {
            return
        }
        this.el.addEventListener('change', () => this.updateState())
        this.updateState()
    }
    updateState() {
        if(this.el.checked) {
            this.elDst.style.display = '';
        } else {
            this.elDst.style.display = 'none';
        }
    }
}

export default HiddenCheckboxManager